/* Router dependencies */
import Vue from 'vue';
import VueRouter from 'vue-router';
import { colorLog } from '@/helpers/utils.js';
import { getMountPointId } from '@/helpers/utils.js';

Vue.use(VueRouter);

/**
 *  baseurl/currentCategorySlug/pageSlug/pageNumber/
 */

const routes = [
  {
    path: '/:currentCategorySlug/:pageSlug?/:pageNumber?/',
    name: 'index',
    component: () =>
      import(
        '@/components/news-and-media-app-hook/news-and-media-list-page.vue'
      ),
    props: true,
  },
  {
    path: '*',
    redirect: { name: 'index' },
  },
];

const app = document.getElementById(getMountPointId());

const router = new VueRouter({
  base: app.dataset.appHookBaseurl,
  mode: 'history',
  routes,
});

const initApp = async (to, from, next) => {
  try {
    if (router.app.$store.state.appReady) {
      // App is ready, API already called
      next();
    } else {
      // App not ready, call API
      // Here you can call some api of initialization
      // Here you can set some data to store
      // Set appReady to true
      await router.app.$store.dispatch('setAppReady', true);

      next();
    }
  } catch (e) {
    colorLog({
      label: 'Router error',
      message: `${e}`,
      themeName: 'red',
    });
    // Set appReady to true
    await router.app.$store.dispatch('setAppReady', true);

    // API error, redirect to homepage
    next({ name: 'index' });
  }
};

router.beforeEach(async (to, from, next) => {
  // Controllo bootstrapper
  if (!router.app.$store.state.vueBootstrapper.ready) {
    // Bootstrapper non completo mi metto in watch
    router.app.$store.watch(
      () => router.app.$store.state.vueBootstrapper.ready,
      (status) => {
        if (status) {
          // Bootstrapper completo, procedo
          initApp(to, from, next);
        }
      }
    );
  } else {
    // Bootstrapper completo, procedo
    initApp(to, from, next);
  }
});

export default router;
